module.exports = __webpack_public_path__ + "static/img/login-icon.166856bb.png";